var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isCSR } from './domain';
import { isMobileApp } from './mobileApp';
import { getAdjustToken } from './utils';
const adjustInstance = () => __awaiter(void 0, void 0, void 0, function* () { return (yield import('@adjustcom/adjust-web-sdk')).default; });
const falsyValues = {
    adjustConsent: false,
    adjustToken: undefined,
};
export const isAdjustEventsReadyToInit = (_a) => {
    var props = __rest(_a, []);
    return Object.entries(props).every(([key, value]) => falsyValues[key] !== value && value !== undefined);
};
export const initAdjust = () => __awaiter(void 0, void 0, void 0, function* () {
    const adjust = yield adjustInstance();
    let adjustConfig = {
        appToken: getAdjustToken(),
        logLevel: 'verbose',
        dataResidency: 'EU',
        environment: 'production',
    };
    adjust.initSdk(adjustConfig);
});
export const initializeAdjustForEventsWhenReady = () => {
    if (!isCSR() || !isMobileApp()) {
        return;
    }
    // Assume that mobile verifies user consent before setting adjust related parameters in url, so we only check for conset token in frontend
    if (isAdjustEventsReadyToInit({ adjustToken: getAdjustToken() })) {
        initAdjust();
    }
};
export const sendAdjustEvent = (eventToken) => {
    adjustInstance()
        .then((adjust) => {
        if (!adjust)
            return;
        adjust.trackEvent({
            eventToken,
        });
    })
        .catch((err) => {
        console.error(err);
    });
};
//# sourceMappingURL=adjustConfig.js.map